import React, { useContext, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { ISuggestedModalContext, SuggestedModalContext } from '../suggestedModalState/suggestedModalContext';
import { IUpdateDishV2 } from 'types';
import { updateDishV2 } from 'backend/dishes';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { convertUndefinedFields } from 'utils/helpers';
import { Form } from 'antd';
import { ModalContent } from 'components/ModalWindows/ModalContent';
import { SuggestedDishesField } from './SuggestedDishesField';

interface IProps {
	onCloseModal: () => void;
	onFailureEvent?: () => void;
	onShowError: () => void;
}

export const EditForm: React.FC<IProps> = ({ onCloseModal, onFailureEvent, onShowError }) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		setSuggestedDishCategory,
		setSuggestedDishSubCategory,
		setFetchedSuggestedDishes,
		setSuggestedDishes,
		removeSuggestedDish,
		dishInfo,
		IDsSelectedRestaurant,
		selectedSuggestedDishCategory,
		selectedSuggestedDishSubCategory,
		fetchedSuggestedDishes,
		selectedSuggestedDishes,
	} = useContext<ISuggestedModalContext>(SuggestedModalContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			selectedSuggestedDishCategory,
			selectedSuggestedDishSubCategory,
			selectedSuggestedDishes,
		});
	}, [selectedSuggestedDishCategory, selectedSuggestedDishSubCategory, selectedSuggestedDishes]);

	const handleAssignRestaurants = async () => {
		if (dishInfo) {
			try {
				const dataForSubmit: IUpdateDishV2 = {
					id: dishInfo.id,
					fileId: '',
					name: dishInfo.name,
					description: dishInfo.description,
					articleNumber: dishInfo.articleNumber,
					externalId: dishInfo.externalId,
					translations: dishInfo.translations,
					overrideScheduleAvailability: dishInfo.overrideScheduleAvailability,
					activationCron: dishInfo.activationCron,
					deactivationCron: dishInfo.deactivationCron,
					restaurantIds: IDsSelectedRestaurant,
					suggestedDishIds: selectedSuggestedDishes,
					additionalDishIds: dishInfo.additionalDishes.map((additionalDish) => additionalDish.id),
					dishModificationIds: dishInfo.dishModifications.map((dishModification) => dishModification.id),
				};
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateDishV2(convertedData);
				onCloseModal();
			} catch (err) {
				onShowError();
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<ModalContent
			onConsentEvent={handleAssignRestaurants}
			onFailureEvent={onFailureEvent ? onFailureEvent : onCloseModal}
			heading="editSuggestedList"
			headerTranslationNameSpace="form"
			translationOfConfirmBtn="saveButton"
			headingAlignment="left"
			centered={false}
			width="60%"
			isDisabledSave={!dishInfo}>
			<Form form={form} name="basic" onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<SuggestedDishesField
					setFetchedSuggestedDishes={setFetchedSuggestedDishes}
					setSuggestedDishCategory={setSuggestedDishCategory}
					setSuggestedDishSubCategory={setSuggestedDishSubCategory}
					setSuggestedDishes={setSuggestedDishes}
					removeSuggestedDish={removeSuggestedDish}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					selectedSuggestedDishCategory={selectedSuggestedDishCategory}
					selectedSuggestedDishSubCategory={selectedSuggestedDishSubCategory}
					selectedSuggestedDishes={selectedSuggestedDishes}
					fetchedSuggestedDishes={fetchedSuggestedDishes}
				/>
			</Form>
		</ModalContent>
	);
};
